import React from "react";

export default function EventJumbotron() {
  return (
    <div className="container flex justify-center items-center custom-bg-about">
      <div className="text-center">
        <h5 className="text-6xl font-bold text-lime-400">Events</h5>

        <p className="text-xl text-white mt-5">
          <span className="text-white mr-10">Home</span>/
          <span className="text-white mx-10">Page</span>/
          <span className="text-lime-400 font-bold ml-10">Events</span>
        </p>
      </div>
    </div>
  );
}
